import { useEffect } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import SignIn from "./component/authentication/signin/signin";
import ForgotPassword from "./component/authentication/forgot-password/forgot-password";
import Sidebar from "./layout/sidebar/sidebar";
import SignUp from "./component/authentication/signUp/stepper/Stepper";
import { routes } from "./routes/routes";
import { useLocation } from "react-router-dom";
import { PageNotFound } from "./component/page-not-found/page-not-found";
import { RestrictUser } from "component/restrict-user/restrictUser";
import SignUpUI from "component/authentication/UI/signUpUI";
import Corporate from "component/authentication/UI/corporatesignUp/signUp/stepper/Stepper";
import ThirdParty from "component/authentication/UI/Third-Party signup/signUp/signUp/stepper/Stepper";
import Lawyers from "component/authentication/UI/Lawyers-signup/signUp/stepper/Stepper";
import ConfirmPassword from "component/authentication/forgot-password/ConfirmPassword";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import * as io from "socket.io-client";
import { useAppSelector } from "store/store";
import { createNewChat, setAllChat, setNewMessage, setSocketConnection } from "store/features/chatSlice";


export const decryptRole: any = (role: any) => {
  if (role == null || role === "") return "";
  try {
    const bytes = CryptoJS.AES.decrypt(role, "1-2");
    const decryptedRole = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedRole || "";
  } catch {
    return "";
  }
};
export let socket: any = null;


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const persistRole = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const socketInstance = useAppSelector((state) => state.chat.socket);

  const isEmptyObj = (obj: {}) => { 

    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;

  };
  let userData = JSON.parse(
    localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null"
  );
  // Treat missing or empty token as logged out (avoids flicker from stale storage)
  const isLoggedIn = Boolean(userData?.token);

  let pathName = location.pathname;

  if (decryptRole(userData?.role)) {
    if (decryptRole(persistRole?.auth?.role) !== decryptRole(userData?.role)) {
      navigate("/restric-user");
    }
  }

  useEffect(() => {
    // Only redirect away from auth pages when user has a valid token (prevents flicker from stale localStorage)
    if (pathName.includes("authentication") && isLoggedIn) {
      navigate(
        userData.role === "Commercial" || userData?.role === "Corporate"
          ? "/c-dashboard"
          : "/"
      );
    }
    if (!userData?.token && userData?.challengeName === "NEW_PASSWORD_REQUIRED") {
      navigate("/users/password-reset-link");
    }
  }, [pathName]);

  useEffect(() => {
    const publicPaths = [
      "/authentication/signin",
      "/signup-users",
      "/authentication/personal_signup/Personal",
      "/authentication/lawyers_signup/Lawyers",
      "/authentication/forgot-password",
    ];
    const isPublicPath =
      publicPaths.includes(pathName) ||
      pathName.includes("/users/password-reset-link") ||
      pathName.includes("/authentication/signup/Corporate") ||
      pathName.includes("/authentication/signup/Commercial") ||
      pathName.includes("/authentication/third_party_signup/ThirdParty");

    if (!isLoggedIn && !isPublicPath) {
      navigate("/authentication/signin");
    }
  }, [pathName, isLoggedIn]);


  useEffect(() => {
    if (isLoggedIn && isEmptyObj(socketInstance)) {

      const socket = io.connect("https://clients-dev.ppcn.co.uk/", {
        auth: (cb: any) => {
          cb({
            accessToken: userData?.token,
          });
        },
      });

      socket.on("connect", () => {
        dispatch(setSocketConnection({ isConnected: true, socket: socket }));
        socket.emit("subscribe", { deviceType: "Browser" });
        socket.emit("getallchats", null, (response: any) => {
          dispatch(setAllChat(response));
        });
      });
      socket.on("getallchats", (data: any) => {
      });
      socket.on("disconnect", () => {
      });
      socket.on("send-message", (data: any) => {
        dispatch(setNewMessage(data))
      });
      socket.on('create-chat', response => {
        dispatch(createNewChat(response.data));
      });
      return () => {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("pong");
      };
    }
  }, [userData?.token]);

  return (
    <Routes>
      {!isLoggedIn && (
        <>
          <Route path="/" element={<Navigate to="/authentication/signin" replace />} />
          <Route path="/authentication/signin" element={<SignIn />} />
          <Route path="/signup-users" element={<SignUpUI />} />
          <Route path="/authentication/personal_signup/:role" element={<SignUp />} />
          <Route path="/authentication/signup/:role" element={<Corporate />} />
          <Route path="/authentication/third_party_signup/:role" element={<ThirdParty />} />
          <Route path="/authentication/lawyers_signup/:role" element={<Lawyers />} />
          <Route path="/authentication/forgot-password" element={<ForgotPassword />} />
          <Route path="/users/password-reset-link" element={<ConfirmPassword />} />
        </>
      )}

      {/* Protected & Dynamic routes: parent path "/*" so Sidebar matches all app paths */}
      {isLoggedIn && (
        <Route path="/*" element={<Sidebar />}>
          {routes.map((routeItem: any, i: number) => {
            if (routeItem.path === "/") {
              return <Route key={i} index element={routeItem.element} />;
            }
            return (
              <Route
                key={i}
                path={routeItem.path.slice(1)}
                element={routeItem.element}
              />
            );
          })}
        </Route>
      )}
      <Route path="/restric-user" element={<RestrictUser />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
